export const DEFAULT_INCOMES = [
  { category: "Salary Income", subcategory: "Salary Income – Self", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Salary Income", subcategory: "Salary Income – Spouse", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Salary Income", subcategory: "Bonus/Incentive – Self", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Salary Income", subcategory: "Bonus/Incentive – Spouse", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Business Income", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Rental Income", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Interest Income", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Investment Income", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
];

export const DEFAULT_EXPENSES = [
  { category: "Household Expenses", subcategory: "Food & Grocery", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Household Expenses", subcategory: "House Rent / Maintenance / Repair", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Household Expenses", subcategory: "Conveyance, Fuel & Maintenance", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Household Expenses", subcategory: "Medicines / Doctor / Healthcare", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Household Expenses", subcategory: "Electricity / Water / Labour / AMCs", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Household Expenses", subcategory: "Mobile / Telephone / Internet", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Household Expenses", subcategory: "Clothes & Accessories", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Lifestyle Expenses", subcategory: "Shopping/Gifts/Electronics", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Lifestyle Expenses", subcategory: "Dining/Movies/Sports", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Lifestyle Expenses", subcategory: "Personal Care/Others", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Lifestyle Expenses", subcategory: "Travel & Annual Vacations", monthly_amount: 0, yearly_amount: 0, is_monthly: false },
  { category: "Dependent Expenses", subcategory: "Children's Schooling/College", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Dependent Expenses", subcategory: "Contribution to Parents/Siblings", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Pure Insurance Premiums", subcategory: "Life Insurance Term", monthly_amount: 0, yearly_amount: 0, is_monthly: false },
  { category: "Pure Insurance Premiums", subcategory: "Mediclaim/PA/CI", monthly_amount: 0, yearly_amount: 0, is_monthly: false },
  { category: "Pure Insurance Premiums", subcategory: "Motor/General Insurance", monthly_amount: 0, yearly_amount: 0, is_monthly: false },
  { category: "Loan Servicing", subcategory: "Home Loan EMI", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Loan Servicing", subcategory: "Car Loan EMI", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Loan Servicing", subcategory: "Personal Loan EMI", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Miscellaneous", subcategory: "Other Expenses", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Miscellaneous", subcategory: "Charity/Donation", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Miscellaneous", subcategory: "Learning/Self-Development", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
];

export const DEFAULT_SAVINGS = [
  { category: "PPF / SSY", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Recurring Deposits (RDs)", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Insurance Premiums (savings plans)", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Mutual Fund SIPs", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
  { category: "Government savings schemes", monthly_amount: 0, yearly_amount: 0, is_monthly: true },
];

export const DEFAULT_BUDGET_BUCKETS = [
  { name: "Financial Freedom", percentage: 10, budget: 0 },
  { name: "Future Goals", percentage: 20, budget: 0 },
  { name: "Recreation", percentage: 10, budget: 0 },
  { name: "Needs & Lifestyle", percentage: 50, budget: 0 },
  { name: "Learning", percentage: 5, budget: 0 },
  { name: "Charity", percentage: 5, budget: 0 },
];

export const DEFAULT_INVESTMENT_ASSETS = {
  debt_assets: [
    { name: "Fixed Deposits", amount: 0 },
    { name: "PPF (Public Provident Fund)", amount: 0 },
    { name: "EPF / NPS / Superannuation", amount: 0 },
    { name: "NSC / POMIS / KVP / RDs etc", amount: 0 },
    { name: "Debt Mutual Funds", amount: 0 },
    { name: "Traditional Insurance Policies (Surrender Value)", amount: 0 },
    { name: "Bonds / Debentures / CDs", amount: 0 },
  ],
  equity_assets: [
    { name: "Direct Equity", amount: 0 },
    { name: "Equity Mutual Funds", amount: 0 },
    { name: "Unit-linked Insurance Policies (Surrender Value)", amount: 0 },
    { name: "PMS/AIF/SIF", amount: 0 },
    { name: "NPS (Equity)", amount: 0 },
  ],
  gold_assets: [
    { name: "Gold (Bars / Coins)", amount: 0 },
    { name: "Gold ETF / Bonds / Funds", amount: 0 },
  ],
  real_estate_assets: [
    { name: "Apartment/House (Investment)", amount: 0 },
    { name: "Plot/Land/Farm", amount: 0 },
    { name: "Real Estate Funds/REITs", amount: 0 },
  ],
};

export const DEFAULT_LIABILITIES = [
  { name: "Home Loan", amount: 0 },
  { name: "Vehicle Loan", amount: 0 },
  { name: "Personal Loan", amount: 0 },
  { name: "Other Loans", amount: 0 },
];
